// @noflow
import notifyPlatform from './reporting';

/**
 * Notify BugSnag of a handled exception or event
 * @param {string|Error} error Error message
 * @param {Object} metaData Metadata
 * @returns {undefined}
 */
const notify = ({ error, metaData, isConsecutive, isSlingStartup }) =>
  notifyPlatform({ error, metaData, isConsecutive, isSlingStartup });

export default notify;
